var map = {
	"./en/account.json": 4493,
	"./en/administration.json": 5576,
	"./en/auth.json": 3468,
	"./en/billing.json": 5325,
	"./en/common.json": 9279,
	"./en/directory.json": 7961,
	"./en/files.json": 1173,
	"./en/generator.json": 4267,
	"./en/help.json": 3461,
	"./en/history.json": 9530,
	"./en/public.json": 1471,
	"./en/secureRequest.json": 9892,
	"./en/share.json": 8801,
	"./en/sms.json": 7599,
	"./en/tester.json": 165,
	"./en/workspace.json": 151,
	"./fr/account.json": 6794,
	"./fr/administration.json": 8677,
	"./fr/auth.json": 8105,
	"./fr/billing.json": 942,
	"./fr/common.json": 7262,
	"./fr/directory.json": 1246,
	"./fr/files.json": 3374,
	"./fr/generator.json": 9504,
	"./fr/help.json": 8560,
	"./fr/history.json": 177,
	"./fr/public.json": 4938,
	"./fr/secureRequest.json": 2711,
	"./fr/share.json": 4862,
	"./fr/sms.json": 2116,
	"./fr/tester.json": 740,
	"./fr/workspace.json": 5944
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2037;